import axios from "axios";
import {
  FETCH_COVIDSUMM_API,
  FETCH_COVIDGUIDELINE_API,
} from "../../../variables/API_ENDPOINTS";

export function fetchCovidSumm(serviceArea_code) {
  return function (dispatch) {
    dispatch({
      type: "FETCH_COVIDSUMM",
    });
    axios
      .post(FETCH_COVIDSUMM_API, { isAdminData: false, serviceArea_code })
      .then((res) => {
        dispatch({
          type: "FETCH_COVIDSUMM_SUCCESS",
          payload: JSON.parse(res.data.body)[0],
        });
      });
  };
}
export function fetchCovidGuideline(serviceArea_code) {
  return function (dispatch) {
    dispatch({
      type: "FETCH_COVIDGUIDELINE",
    });
    axios
      .post(FETCH_COVIDGUIDELINE_API, { isAdminData: false, serviceArea_code })
      .then((res) => {
        dispatch({
          type: "FETCH_COVIDGUIDELINE_SUCCESS",
          payload: JSON.parse(res.data.body)[0],
        });
      });
  };
}
